import { render, staticRenderFns } from "./retirada_detalhe.vue?vue&type=template&id=05d5d712&scoped=true"
import script from "./retirada_detalhe.vue?vue&type=script&lang=js"
export * from "./retirada_detalhe.vue?vue&type=script&lang=js"
import style0 from "./retirada_detalhe.vue?vue&type=style&index=0&id=05d5d712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d5d712",
  null
  
)

export default component.exports